var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD400(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5317 8.05595C11.8857 8.01895 12.2449 8 12.6083 8C17.469 8 21.5661 11.3898 22.821 16.0139C22.9215 16.0073 23.0225 16.0031 23.1241 16.0012C23.0828 16.0005 23.0414 16.0001 23 16.0001L22.9664 16.0002L24.5 16H24.5602C26.4654 15.9679 28 14.4129 28 12.5C28 10.567 26.433 9 24.5 9C23.8509 9 23.2432 9.17666 22.7221 9.48451C22.7206 8.92577 22.6357 8.38663 22.4793 7.87885C21.7001 5.62147 19.5567 4 17.0345 4C14.4468 4 12.2578 5.70676 11.5317 8.05595ZM27.1766 17.3059C28.8861 18.5759 30 20.653 30 23C30 26.866 26.9776 30 23.2493 30C23.1658 30 23.0827 29.9984 23 29.9953V30H12.7671V29.9988C12.7143 29.9996 12.6613 30 12.6083 30C6.74949 30 2 25.0751 2 19C2 14.0943 5.09693 9.9387 9.37412 8.52057C9.96691 4.82406 13.1709 2 17.0345 2C20.3494 2 23.1787 4.07884 24.2899 7.00394C24.3596 7.00132 24.4296 7 24.5 7C27.5375 7 30 9.46243 30 12.5C30 14.5659 28.8609 16.3658 27.1766 17.3059ZM23 28H12.7671H12.652H12.6083C7.92179 28 4 24.0395 4 19C4 13.9605 7.92179 10 12.6083 10C16.5839 10 20.0091 12.85 20.9569 16.7911L20.9599 16.7899C21.0937 17.3367 21.1791 17.9037 21.2108 18.4855C21.8339 18.1732 22.5272 18 23.2493 18C25.8053 18 28 20.1696 28 23C28 25.8105 25.8359 27.9695 23.3029 27.9996L23 28Z",
    fill: "url(#paint0_linear_9_1040)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_1040",
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD400);
export default __webpack_public_path__ + "static/media/d400.7e24bd158cdc857d6089060a137ac56c.svg";
export { ForwardRef as ReactComponent };